import React from 'react';
import Image from 'gatsby-image'
import {useStaticQuery, graphql} from 'gatsby'



const query = graphql`
query {
    data:     allContentfulNoticia {
        edges {
          node {
            title
            contentNoticia {
              contentNoticia
            }
            img {
              fluid {
                ...GatsbyContentfulFluid
              }
            }
          }
        }
      }
}
`

const BlogDetailsContentWrapper = ({post,sidebar}) => {

    const data = useStaticQuery(query)
    console.log(data.data.edges)
    console.log(data.data.edges[2].node.img.fluid)
    return (
        <div className="container">
        <article className="blog-post-details" style={{margin:'60px 0'}}>

            <div className="blog-post-txt-wrap">
                <div className="row">
                    {
                        !sidebar ? (
<div></div>
                        ):null
                    }

                    <div className={`m-auto order-0 ${!sidebar ? 'col-md-8 col-lg-8': 'col-12'}`}>
                        <div className="blog-post-txt" style={{margin:'0 auto'}}>
            <figure className="blog-post-thumb">
                <Image fluid={data.data.edges[2].node.img.fluid} alt='noticias imagen 1'/>
            </figure>
                            <h2 className="h3">{data.data.edges[2].node.title}</h2>

                            <p style={{textAlign:'center'}}>{data.data.edges[2].node.contentNoticia.contentNoticia}</p>
                        </div>

                        <div className="share-article text-center">
                            <h6>Ver mas</h6>
                            <div className="member-social-icons justify-content-center">

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </article>

        <article className="blog-post-details" style={{margin:'60px 0'}}>

<div className="blog-post-txt-wrap">
    <div className="row">
        {
            !sidebar ? (
<div></div>
            ):null
        }

        <div className={`m-auto order-0 ${!sidebar ? 'col-md-8 col-lg-8': 'col-12'}`}>
            <div className="blog-post-txt" style={{margin:'0 auto'}}>
<figure className="blog-post-thumb">
<Image fluid={data.data.edges[1].node.img.fluid} alt='noticias imagen 2'/>
</figure>
                <h2 className="h3">{data.data.edges[1].node.title}</h2>

                <p style={{textAlign:'center'}}>{data.data.edges[1].node.contentNoticia.contentNoticia}</p>
            </div>

            <div className="share-article text-center">
                <h6>Ver mas</h6>
                <div className="member-social-icons justify-content-center">

                </div>
            </div>
        </div>
    </div>
</div>
</article>

<article className="blog-post-details" style={{margin:'60px 0'}}>

<div className="blog-post-txt-wrap">
    <div className="row">
        {
            !sidebar ? (
<div></div>
            ):null
        }

        <div className={`m-auto order-0 ${!sidebar ? 'col-md-8 col-lg-8': 'col-12'}`}>
            <div className="blog-post-txt" style={{margin:'0 auto'}}>
<figure className="blog-post-thumb">
<Image fluid={data.data.edges[0].node.img.fluid} alt='noticias imagen 3'/>
</figure>
                <h2 className="h3">{data.data.edges[0].node.title}</h2>

                <p style={{textAlign:'center'}}>{data.data.edges[0].node.contentNoticia.contentNoticia} </p>
            </div>

            <div className="share-article text-center">
                <h6>fin de noticias</h6>
                <div className="member-social-icons justify-content-center">

                </div>
            </div>
        </div>
    </div>
</div>
</article>
        </div>
    );
};

export default BlogDetailsContentWrapper;